// react
import React, {useEffect} from "react";

// third-party
import {Helmet} from "react-helmet-async";
// data stubs
import {useSelector} from "react-redux";
import {useState} from "react";
import {url} from "../../helper";

// import Content from "./Content";
import {useHistory} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import Breadcrumbs from "../shared/Breadcrumbs";
import PageHeader from "../shared/PageHeader";

function SiteCustomPage(props) {
    const history = useHistory();
    const selectedData = useSelector((state) => state.locale);
    const {id, location} = props;
    const [content, setContent] = useState();
    const pages = useSelector(state => state.pages)

    const pageTitle = pages?.find(el => el.page_id === +id)?.name


    useEffect(() => {
        let canceled = false;

        fetch(`${url}/api/cms/pages?id=${id}&locale=${selectedData}`)
            .then((response) => response.json())
            .then((res) => {
                if (res === undefined || res.length == 0) {
                    history.push("/");
                } else {
                    setContent(res);
                }
            });
    }, [id, pages]);

    const partnersImages = [];
    const clientsImages = [];

    for (let i = 46; i <= 207; i++) {
        partnersImages.push(`images/PARTNERS/${i}.png`);
    }

    for (let i = 1; i <= 45; i++) {
        clientsImages.push(`images/CLIENTS/${i}.png`);
    }

    const breadcrumb = [
        {title: <FormattedMessage id="home" defaultMessage="home"/>, url: url},
        {title: pageTitle, url: location.pathname},
    ];

    const pageContent = +id === 8
        ?
        <div className="image_container">
            {partnersImages.map((image, index) => {
                return <div className="image">
                    <img src={image} alt={`image${index + 1}`}/>
                </div>
            })}
        </div>
        : +id === 7
            ?
            <div className="image_container">
                {clientsImages.map((image, index) => {
                    return <div className="image">
                        <img src={image} alt={`image${index + 1}`}/>
                    </div>
                })}
            </div>
            :
            <div
                className="dangerous-html-page"
                dangerouslySetInnerHTML={{__html: content ? content.data?.[0]?.html_content : ""}}
            />

    return (
        <React.Fragment>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content="Custom description"/>
            </Helmet>
            <Breadcrumbs breadcrumb={breadcrumb}/>
            {/*<Content text={content}  {...props}/>*/}
            <div className="container">
                <PageHeader header={pageTitle}/>
                {pageContent}
            </div>
        </React.Fragment>
    );
}

export default SiteCustomPage;



